import ReactDOM from "react-dom/client";
import React from "react";
import { Search } from "./components/search/Search";

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}

const containers = <NodeListOf<HTMLElement>>document.querySelectorAll(".domain-search-section");

containers.forEach((container) => {
    const contentElement = <HTMLElement>container.querySelector(".content");
    const root = ReactDOM.createRoot(contentElement);
    root.render(React.createElement(Search, { data: { query: container.dataset.query } }));
});
